// extracted by mini-css-extract-plugin
export var orderDetails = "_rb-2";
export var orderImage = "_rb-1";
export var orderMeta = "_rb-3";
export var orderSummary = "_rb-0";
export var rightArrow = "_rb-4";